import React from 'react';
import email from '../../components/email.json';
import { detectBrowser } from '../../js/common';
import { Route } from 'react-router';
import pixImg from '../../images/pix.gif';
import OptinAboveBox from '../../templates/optinabovebox/OptinAboveBox';
import OptinAboveBoxFr from '../../templates/optinaboveboxfr/OptinAboveBoxFr';
import OptinInsideBox from '../../templates/optininsidebox/OptinInsideBox';
import OptinInsideBoxFr from '../../templates/optininsideboxfr/OptinInsideBoxFr';
import classNames from 'classnames';

export default class OptinLandingPressed extends React.Component {
  render() {
    const badBrowser = detectBrowser();
    const boolTrue = true;
    return (
      <main>
        <div id='optinMiddle'>
          <div className='centerWrap'>
            <div className='OptinConfirmBar'>
              <div
                className='OptinConfirmContent'
                id='confirmBarID'
                style={{ outline: 'none', border: 'none' }}
                tabIndex='0'
              >
                <p className='OptinConfirmContent'>
                  <img
                    src={pixImg}
                    alt={
                      email.optin.pressed.ui.body.confirmationBar.descriptive
                        .eng
                    }
                  />
                  <strong>
                    {email.optin.confirmation.ui.body.pressedBar.eng}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div className={classNames('content', 'centerWrap')}>
            <p>{email.optin.body.display.french.message.eng}</p>
            <Route component={OptinAboveBox} />
            <div className=' borderBox'>
              <Route component={OptinInsideBox} />
              <div className='buttonContent'>
                <button
                  disabled={boolTrue}
                  name='optinButton'
                  id='optinButton'
                  className='optinButtonPressed'
                >
                  {email.optin.landing.ui.body.button.buttonText.eng}
                </button>
              </div>
            </div>
          </div>
          <div className={classNames('content', 'centerWrap')}>
            <Route component={OptinAboveBoxFr} />
            <div className=' borderBox'>
              <Route component={OptinInsideBoxFr} />
              <div className='buttonContent'>
                <button
                  disabled={boolTrue}
                  name='optinButton'
                  id='optinButton'
                  className='optinButtonPressed'
                >
                  {email.optin.landing.ui.body.button.buttonText.fr}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}
